"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryTransformer = void 0;
const StoryEventObject_1 = require("../domain/StoryEventObject");
const JsonUtil_1 = require("../../cutil/JsonUtil");
const StudioProjectAttributesV3Node_1 = require("../../project/domain/StudioProjectAttributesV3Node");
const StoryNodeType_1 = require("../domain/StoryNodeType");
const StoryNodeUtil_1 = require("../domain/StoryNodeUtil");
const StoryLineOptionsUtil_1 = require("../domain/StoryLineOptionsUtil");
const StoryTransformerUtil_1 = require("./StoryTransformerUtil");
const StudioProjectAttributesV3NodeData_1 = require("../../project/domain/StudioProjectAttributesV3NodeData");
const StoryNodeState_1 = require("../domain/StoryNodeState");
const StoryNodeDisplayType_1 = require("../domain/StoryNodeDisplayType");
const LangUtil_1 = require("../../cutil/LangUtil");
const CustomApiTransformUtil_1 = require("../../storyV2/response/customApiHandler/util/CustomApiTransformUtil");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class StoryTransformer {
    static transform(originalData, storyObject, story) {
        const node = StoryEventObject_1.StoryEventObject.asNode(storyObject);
        if (node) {
            if (node.children.length !== 0 && node.options.type === StoryNodeType_1.StoryNodeType.CUSTOMGROUP) {
                return StoryTransformer.transformGroupNode(node, story);
            }
            return StoryTransformer.transformNode(originalData, node, story);
        }
        const edge = StoryEventObject_1.StoryEventObject.asEdge(storyObject);
        if (edge) {
            return StoryTransformer.transformEdge(originalData, edge);
        }
        return originalData;
    }
    static transformGroupNode(storyNode, story) {
        const groupNodeProjectModel = StoryTransformerUtil_1.StoryTransformerUtil.createEmptyGroupUiData();
        const nodeProjectModel = JsonUtil_1.JsonUtil.toModelFromType(StudioProjectAttributesV3Node_1.StudioProjectAttributesV3Node, groupNodeProjectModel);
        if (!nodeProjectModel)
            return [groupNodeProjectModel];
        nodeProjectModel.type = StoryNodeType_1.StoryNodeType.CUSTOMGROUP;
        nodeProjectModel.id = storyNode.id;
        let dataModel = nodeProjectModel?.data;
        if (dataModel) {
            const nodeData = dataModel;
            const childIds = storyNode.children.map(n => n.options.id);
            nodeData.childNode = childIds;
            nodeProjectModel.data = nodeData;
        }
        const jsonStr = JsonUtil_1.JsonUtil.stringify(nodeProjectModel);
        if (!jsonStr)
            return [groupNodeProjectModel];
        const newData = JSON.parse(jsonStr);
        const returnArr = [newData];
        storyNode.children.forEach(child => {
            const childObject = StoryTransformer.transformNode(StoryTransformerUtil_1.StoryTransformerUtil.createEmptyNodeUiData(), child, story, storyNode.id, "parent");
            returnArr.push(childObject);
        });
        return returnArr;
    }
    static transformNode(originalData, storyNode, story, parentNode, extent) {
        const nodeProjectModel = JsonUtil_1.JsonUtil.toModelFromType(StudioProjectAttributesV3Node_1.StudioProjectAttributesV3Node, originalData);
        if (!nodeProjectModel)
            return originalData;
        nodeProjectModel.id = storyNode.options.id;
        nodeProjectModel.type = StoryNodeType_1.StoryNodeType.CUSTOMNODE;
        nodeProjectModel.parentNode = parentNode;
        nodeProjectModel.extent = extent;
        let dataModel = nodeProjectModel?.data || new StudioProjectAttributesV3NodeData_1.StudioProjectAttributesV3NodeData();
        let nodeData = dataModel;
        const displayType = StoryTransformerUtil_1.StoryTransformerUtil.createDisplayType(storyNode, story);
        nodeData.displayType = displayType;
        nodeData.loading =
            storyNode.state === StoryNodeState_1.StoryNodeState.LOADING ||
                ((0, is_blank_1.default)(storyNode.content) && storyNode.state === StoryNodeState_1.StoryNodeState.RECEIVING);
        // BSF-6868： 返回成功的情况，一定记得给errorText 字段复制为空字符串
        if (storyNode.state === StoryNodeState_1.StoryNodeState.ERROR) {
            nodeData.errorText = storyNode.content;
            nodeData.textAreaValue = "";
        }
        else if (displayType && CustomApiTransformUtil_1.CustomApiTransformUtil.isUploadFileType(displayType)) {
            const loading = storyNode.state === StoryNodeState_1.StoryNodeState.LOADING || storyNode.state === StoryNodeState_1.StoryNodeState.RECEIVING;
            let content = (0, LangUtil_1.tryBlock)(() => JSON.parse(storyNode.content));
            if (!content.data) {
                nodeData = { ...nodeData, ...{ loading } };
            }
            else {
                content.data.loading = loading;
                nodeData = { ...nodeData, ...content.data };
            }
            nodeData.errorText = "";
        }
        else {
            nodeData.errorText = "";
            nodeData.textAreaValue = StoryTransformerUtil_1.StoryTransformerUtil.createTextAreaValue(storyNode, story, displayType);
        }
        if (displayType == StoryNodeDisplayType_1.StoryNodeDisplayType.STOCKINFO || displayType == StoryNodeDisplayType_1.StoryNodeDisplayType.HTMLTEMPLATE) {
            if (storyNode.state == StoryNodeState_1.StoryNodeState.LOADING || storyNode.state == StoryNodeState_1.StoryNodeState.RECEIVING) {
                nodeData.stockLoading = true;
            }
            else {
                nodeData.stockLoading = false;
            }
        }
        nodeData.showFeedback = storyNode.state == StoryNodeState_1.StoryNodeState.COMPLETED ? true : false;
        nodeData.parentNodeId = parentNode;
        nodeData.showStopGenerateBtn =
            storyNode.state == StoryNodeState_1.StoryNodeState.RECEIVING || storyNode.state == StoryNodeState_1.StoryNodeState.LOADING;
        nodeData = StoryTransformer.setIndexRef(nodeData, story);
        nodeProjectModel.data = nodeData;
        const jsonStr = JsonUtil_1.JsonUtil.stringify(nodeProjectModel);
        if (!jsonStr)
            return originalData;
        const newData = JSON.parse(jsonStr);
        return newData;
    }
    static setIndexRef(dataModel, story) {
        const maxNodeIndex = StoryNodeUtil_1.StoryNodeUtil.maxIdNumber(story);
        const nodeIndexRef = dataModel.nodeIndexRef;
        if (nodeIndexRef) {
            if (nodeIndexRef.current == undefined || nodeIndexRef.current < maxNodeIndex + 1) {
                nodeIndexRef.current = maxNodeIndex + 1;
                dataModel.nodeIndexRef = nodeIndexRef;
            }
        }
        const maxLineIndex = StoryLineOptionsUtil_1.StoryLineOptionsUtil.maxIdNumber(story);
        const edgeIndexRef = dataModel.edgeIndexRef;
        if (edgeIndexRef) {
            if (edgeIndexRef.current == undefined || edgeIndexRef.current < maxLineIndex + 1) {
                edgeIndexRef.current = maxLineIndex + 1;
                dataModel.edgeIndexRef = edgeIndexRef;
            }
        }
        return dataModel;
    }
    static transformEdge(originalData, storyNode) {
        return originalData;
    }
}
exports.StoryTransformer = StoryTransformer;
